import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { ImportReport } from "@/pages/admin/ImportReport";

export default function AdminImport() {
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [jobs, setJobs] = useState([]);
  const refresh = useCallback(() => api.get("/admin/imports").then((r) => setJobs(r.data)), []);

  useEffect(() => {
    refresh();
  }, [refresh]);
  useEffect(() => {
    if (jobs[0]?.images?.status !== "in corso") return undefined;
    const t = setInterval(refresh, 3000);
    return () => clearInterval(t);
  }, [jobs, refresh]);

  const upload = async () => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      await api.post("/admin/import", fd);
      toast.success("Catalogo importato");
      await refresh();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-import-page">
      <h1 className="font-display text-3xl font-semibold">Importa CSV Ecwid</h1>
      <p className="mt-2 max-w-2xl text-sm text-slate-400">
        Carica il file CSV esportato da Ecwid. Nomi, prezzi, descrizioni, categorie, immagini, disponibilità e opzioni vengono importati; le immagini sono copiate nel sito.
        Reimportando lo stesso file i prodotti esistenti vengono aggiornati (le modifiche fatte qui su quei prodotti verranno sovrascritte). Il negozio Ecwid non viene modificato. Attenzione: una nuova importazione ripristina i prezzi Ecwid (annullando l'eventuale aumento del 4%).
      </p>
      <div className="mt-6 flex flex-col gap-3 rounded-2xl border border-dashed border-white/20 p-6 sm:flex-row sm:items-center">
        <input type="file" accept=".csv,text/csv" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="import-file-input" className="flex-1 text-sm file:mr-4 file:rounded-full file:border-0 file:bg-white/10 file:px-4 file:py-2 file:text-white" />
        <button disabled={!file || busy} onClick={upload} data-testid="import-submit-btn" className="h-11 rounded-full bg-[#0066FF] px-6 text-sm font-medium disabled:opacity-40">
          {busy ? "Importazione…" : "Importa catalogo"}
        </button>
      </div>
      <h2 className="mt-10 font-display text-xl font-semibold">Storico importazioni</h2>
      {jobs.length ? jobs.map((j) => <ImportReport key={j.id} job={j} />) : <p className="mt-4 text-sm text-slate-400">Nessuna importazione.</p>}
    </div>
  );
}
